export enum EditorMode {
  EchoMD = "EchoMD",
  SourceCode = "SourceCode",
  Preview = "Preview",
}
